module.exports = __webpack_public_path__ + "img/metabolic.8dfd0e73.png";